export const GET_SUBCONTRACTOR_LISTING = "GET_SUBCONTRACTOR_LISTING";
export const GET_SUBCONTRACTOR_DETAIL = "GET_SUBCONTRACTOR_DETAIL";
export const CREW_FORM_DATA = "CREW_FORM_DATA";
export const GET_CREW_LISTING = "GET_CREW_LISTING";
export const GET_CREW_DETAIL = "GET_CREW_DETAIL";
